<template>
  <div>
    <nav class="navbar is-spaced is-fixed-top" role="navigation" aria-label="main navigation">
      <div class="navbar-brand">
        <a class="navbar-item">
          Effigon
        </a>

        <a role="button" class="navbar-burger burger" aria-label="menu" aria-expanded="false"
           data-target="navbarBasicExample">
          <span aria-hidden="true"></span>
          <span aria-hidden="true"></span>
          <span aria-hidden="true"></span>
        </a>
      </div>

      <div id="navbarBasicExample" class="navbar-menu">
        <div class="navbar-end" v-if="$route.path === '/'">
          <a class="navbar-item" href="/#" v-scroll-to="'#home'">{{ $t('nav_home') }}</a>
          <a class="navbar-item" href="/#" v-scroll-to="'#services'">{{ $t('nav_services') }}</a>
          <a class="navbar-item" href="/#" v-scroll-to="'#about'">{{ $t('nav_about') }}</a>
          <a class="navbar-item" href="/#" v-scroll-to="'#portfolio'">{{ $t('nav_portfolio') }}</a>
          <a class="navbar-item" href="/#" v-scroll-to="'#contact'">{{ $t('nav_contact') }}</a>
          <div class="navbar-item">
            <div class="buttons">
              <a class="button is-info is-outlined is-rounded" href="#" v-scroll-to="'#contact'">
                {{ $t('nav_contact_button') }}
              </a>
            </div>
          </div>
          <a
            class="navbar-item"
            @click="changeLanguage('en')"
            v-if="lang === 'de'"
          ><img src="@/assets/United_Kingdom.png" alt="en"></a>
          <a
            class="navbar-item"
            @click="changeLanguage('de')"
            v-else
          ><img src="@/assets/Germany.png" alt="en"></a>
        </div>
        <div class="navbar-end" v-else>
          <router-link class="navbar-item" :to="{ name: 'home'}">
            {{ $t('nav_home') }}
          </router-link>
          <router-link class="navbar-item" :to="{ name: 'home'}">
            {{ $t('nav_services') }}
          </router-link>
          <router-link class="navbar-item" :to="{ name: 'home'}">
            {{ $t('nav_about') }}
          </router-link>
          <router-link class="navbar-item" :to="{ name: 'home'}">
            {{ $t('nav_portfolio') }}
          </router-link>
          <router-link class="navbar-item" :to="{ name: 'home'}">
            {{ $t('nav_contact') }}
          </router-link>
          <div class="navbar-item">
            <div class="buttons">
              <a class="button is-info is-outlined is-rounded" href="#" v-scroll-to="'#contact'">
                {{ $t('nav_contact_button') }}
              </a>
            </div>
          </div>
          <a
            class="navbar-item"
            @click="changeLanguage('en')"
            v-if="lang === 'de'"
          ><img src="@/assets/United_Kingdom.png" alt="en"></a>
          <a
            class="navbar-item"
            @click="changeLanguage('de')"
            v-else
          ><img src="@/assets/Germany.png" alt="en"></a>
        </div>
      </div>
    </nav>
  </div>
</template>

<script>

export default {
  name: 'NavBar',
  data() {
    return {
      lang: 'en',
    };
  },
  methods: {
    changeLanguage(lang) {
      this.$i18n.locale = lang;
      this.lang = lang;
    },
  },
};

document.addEventListener('DOMContentLoaded', () => {

  // Get all "navbar-burger" elements
  const $navbarBurgers = Array.prototype.slice.call(document.querySelectorAll('.navbar-burger'), 0);

  // Check if there are any navbar burgers
  if ($navbarBurgers.length > 0) {

    // Add a click event on each of them
    $navbarBurgers.forEach( el => {
      el.addEventListener('click', () => {

        // Get the target from the "data-target" attribute
        const target = el.dataset.target;
        const $target = document.getElementById(target);

        // Toggle the "is-active" class on both the "navbar-burger" and the "navbar-menu"
        el.classList.toggle('is-active');
        $target.classList.toggle('is-active');

      });
    });
  }

});

</script>
